import { Component, Input, OnInit } from '@angular/core';
import { ListitemBuilder } from '././../../../../shared/dropdown-list/ListItemBuilder';
import { FiltroService } from '././../../../../shared/filtro/filtro.service';

@Component({
  selector: 'app-despesa-filtro',
  templateUrl: './despesa-filtro.component.html',
  styleUrls: ['./despesa-filtro.component.css']
})
export class DespesaFiltroComponent implements OnInit {

  @Input() filtros: any;

  dealers = [];
  categoriaDespesa = [];
  mes: any;

  constructor(private service: FiltroService) { }

  ngOnInit() {
    this.carregaMes();
    this.preencherDealers();
    this.preencherCategoriaDespesas();
  }

  preencherDealers() {
    this.service.buscar('dealer')
      .then(r => { this.dealers = r.filtros; });
  }

  preencherCategoriaDespesas() {
    this.service.buscar('categoria_despesa')
      .then(r => { this.categoriaDespesa = r.filtros; });
  }

  set CategoriaDespesa(id: any) { this.filtros.id_categoria_despesa = this.tratarSetDropDown(id); }
  get CategoriaDespesa(): any { return this.tratarGetDropDown(this.filtros.id_categoria_despesa); }

  set Dealer(id: any) { this.filtros.id_dealer = this.tratarSetDropDown(id); }
  get Dealer(): any { return this.tratarGetDropDown(this.filtros.id_dealer); }

  set Mes(id: any) { this.filtros.mes = this.tratarSetDropDown(id); }
  get Mes(): any { return this.tratarGetDropDown(this.filtros.mes); }

  tratarSetDropDown(id: string): number {
    if (id) {
      return +id;
    } else {
      return null;
    }
  }

  tratarGetDropDown(selecionado: any): string {
    if (selecionado === null || selecionado === undefined) {
      return '';
    }
    return selecionado;
  }

  private carregaMes() {
    this.mes = 
      new ListitemBuilder()
        .add(1, 1)
        .add(2, 2)
        .add(3, 3)
        .add(4, 4)
        .add(5, 5)
        .add(6, 6)
        .add(7, 7)
        .add(8, 8)
        .add(9, 9)
        .add(10, 10)
        .add(11, 11)
        .add(12, 12)
        .build();
  }

  limparFiltros() {
    this.filtros.id = '';
    this.filtros.valor = '';
    this.Dealer = '';
    this.Mes = '';
    this.CategoriaDespesa = '';
    this.filtros.ano = '';
  }
}
